/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_View_ListInputs */

const en_colleague_view_list = /** @type {(inputs: Colleague_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

const ja_colleague_view_list = /** @type {(inputs: Colleague_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト`)
};

const fr_colleague_view_list = /** @type {(inputs: Colleague_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

const de_colleague_view_list = /** @type {(inputs: Colleague_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Colleague_View_ListInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_view_list = /** @type {((inputs?: Colleague_View_ListInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_View_ListInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_view_list(inputs)
	if (locale === "ja") return ja_colleague_view_list(inputs)
	if (locale === "fr") return fr_colleague_view_list(inputs)
	return de_colleague_view_list(inputs)
});